export interface Fournisseur {
  id: string;
  name: string;
  lot: string;
  ville: string;
}

export const MOCK_FOURNISSEURS: Fournisseur[] = [
  // Maçonnerie / Gros œuvre
  { id: 'f1',  name: 'Bâtiment Pro',        lot: 'Maçonnerie',     ville: 'Paris'     },
  { id: 'f2',  name: 'BTP Renard',           lot: 'Gros œuvre',     ville: 'Paris'     },
  { id: 'f3',  name: 'Maçonnerie Atlante',   lot: 'Maçonnerie',     ville: 'Nantes'    },
  { id: 'f4',  name: 'BTP Normandie',        lot: 'Gros œuvre',     ville: 'Rouen'     },
  { id: 'f5',  name: 'Béton Services Sud',   lot: 'Maçonnerie',     ville: 'Marseille' },
  // Électricité
  { id: 'f6',  name: 'ElectraPlus',          lot: 'Électricité',    ville: 'Lyon'      },
  { id: 'f7',  name: 'ProElec Rhône',        lot: 'Électricité',    ville: 'Lyon'      },
  { id: 'f8',  name: 'Électricité Garnier',  lot: 'Électricité',    ville: 'Paris'     },
  { id: 'f9',  name: 'Voltex Idf',           lot: 'Électricité',    ville: 'Paris'     },
  // Plomberie / Sanitaire
  { id: 'f10', name: 'Plomb & Co',           lot: 'Plomberie',      ville: 'Marseille' },
  { id: 'f11', name: 'Plomberie Martin',     lot: 'Plomberie',      ville: 'Paris'     },
  { id: 'f12', name: 'Sanitaire Express',    lot: 'Plomberie',      ville: 'Bordeaux'  },
  // CVC
  { id: 'f13', name: 'Chauffage Dupont',     lot: 'CVC',            ville: 'Bordeaux'  },
  { id: 'f14', name: 'Clim Méditerranée',    lot: 'CVC',            ville: 'Marseille' },
  { id: 'f15', name: 'Thermique Ouest',      lot: 'CVC',            ville: 'Nantes'    },
  // Menuiserie
  { id: 'f16', name: 'Menuiserie Martin',    lot: 'Menuiserie',     ville: 'Nantes'    },
  { id: 'f17', name: 'Bois & Châssis',       lot: 'Menuiserie',     ville: 'Bordeaux'  },
  { id: 'f18', name: 'Ébénisterie Lefort',   lot: 'Menuiserie',     ville: 'Lyon'      },
  // Peinture
  { id: 'f19', name: 'Peinture Leblanc',     lot: 'Peinture',       ville: 'Paris'     },
  { id: 'f20', name: 'Décor & Couleurs',     lot: 'Peinture',       ville: 'Lyon'      },
  // Carrelage / Revêtement sol
  { id: 'f21', name: 'Carrelages du Sud',    lot: 'Carrelage',      ville: 'Marseille' },
  { id: 'f22', name: 'Parquet & Bois',       lot: 'Revêtement sol', ville: 'Bordeaux'  },
  { id: 'f23', name: 'Sols Design',          lot: 'Revêtement sol', ville: 'Paris'     },
  // Isolation
  { id: 'f24', name: 'Isolation Express',    lot: 'Isolation',      ville: 'Lyon'      },
  { id: 'f25', name: 'Thermo Habitat',       lot: 'Isolation',      ville: 'Paris'     },
  // Façade / Toiture
  { id: 'f26', name: 'Vitrage & Façades',    lot: 'Façade',         ville: 'Bordeaux'  },
  { id: 'f27', name: 'Couverture Moreau',    lot: 'Toiture',        ville: 'Nantes'    },
  { id: 'f28', name: 'Toit Sécurisé',       lot: 'Toiture',        ville: 'Paris'     },
  // Serrurerie / Métallerie
  { id: 'f29', name: 'Serrurerie Dupuis',    lot: 'Serrurerie',     ville: 'Paris'     },
  { id: 'f30', name: 'Métal Pro',            lot: 'Métallerie',     ville: 'Rouen'     },
  // Divers
  { id: 'f31', name: 'Démolition Rapide',    lot: 'Démolition',     ville: 'Lyon'      },
  { id: 'f32', name: 'Stuccaturo Roma',      lot: 'Enduits',        ville: 'Nice'      },
  { id: 'f33', name: 'VRD Experts',          lot: 'VRD',            ville: 'Paris'     },
  { id: 'f34', name: 'Échafaudage Plus',     lot: 'Échafaudage',    ville: 'Marseille' },
  { id: 'f35', name: 'Ascenseur Service',    lot: 'Ascenseur',      ville: 'Paris'     },
  // Acier (armatures, treillis soudés, profilés)
  { id: 'f36', name: 'Aciéries de France',   lot: 'Acier',          ville: 'Paris'     },
  { id: 'f37', name: 'Riva Acier',           lot: 'Acier',          ville: 'Lyon'      },
  { id: 'f38', name: 'ArcelorMittal IDF',    lot: 'Acier',          ville: 'Paris'     },
  { id: 'f39', name: 'Acier Service Sud',    lot: 'Acier',          ville: 'Marseille' },
  // Béton (BPE, prêt à l'emploi)
  { id: 'f40', name: 'Lafarge BPE',          lot: 'Béton',          ville: 'Paris'     },
  { id: 'f41', name: 'Cemex Centre',         lot: 'Béton',          ville: 'Lyon'      },
  { id: 'f42', name: 'Vicat Sud',            lot: 'Béton',          ville: 'Marseille' },
  { id: 'f43', name: 'Holcim Atlantique',    lot: 'Béton',          ville: 'Nantes'    },
  // Coffrage (location, montage, banches)
  { id: 'f44', name: 'PERI Coffrages',       lot: 'Coffrage',       ville: 'Paris'     },
  { id: 'f45', name: 'Doka France',          lot: 'Coffrage',       ville: 'Lyon'      },
  { id: 'f46', name: 'Hussor Erecta',        lot: 'Coffrage',       ville: 'Strasbourg'},
  { id: 'f47', name: 'Coffrage Pro Ouest',   lot: 'Coffrage',       ville: 'Nantes'    },
];
